import { jsx as _jsx } from "react/jsx-runtime";
import PageNavBreadcrumbs from "src/features/breadcrumbs/PageNavBreadcrumbs";
import BaseHeader from "src/pages/layout/Header";
const Header = () => {
    return (_jsx(BaseHeader, { children: _jsx(PageNavBreadcrumbs, { mode: "dark" }) }));
};
export default Header;
